import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import { WarningProductModal } from "../../../../configs/warningProductModal";
import { CreateAccountingAccountTitleBar } from "../../../../configs/accountingAccount";

interface TitleProps {
    title: string;
    setValidated: (validated: boolean) => void;
    submitForm: Function;
    isLoading: boolean;
}

const Title = ({ title, setValidated, submitForm, isLoading }: TitleProps) => {
    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        setValidated(true);
        await submitForm();
    };

    const titleActions: TitleAction[] = [
        {
            title: CreateAccountingAccountTitleBar.cancelButton,
            variant: "outlined",
            onClick: () => setIsOpenCancelModal(true),
        },
        {
            title: CreateAccountingAccountTitleBar.addButton,
            variant: "contained",
            onClick: handleSubmit,
            isLoading: isLoading,
        },
    ];

    return (
        <>
            <TitleRow title={title} actions={titleActions} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={WarningProductModal.title}
                    contentText={WarningProductModal.context}
                    handleConfirm={() => navigate("/accounting-accounts/")}
                    handleClose={() => setIsOpenCancelModal(false)}
                />
            )}
        </>
    );
};

export default Title;
